<nav class="sidenav">
  <div class="sidenav-container-icons">
    <figure class="tooltip-container" (click)="goBack()">
      <app-arrow-back></app-arrow-back>
    </figure>
  </div>
  <div class="sidenav-container-icons">
    <figure *ngFor="let menu of authorizations.menu_options" class="tooltip-container" (click)="reload(menu.menu_id)">
      <i [ngClass]="getClass(menu.menu_id)"></i>
      <span *ngIf="menu.menu_id === 9 && pendingAppointments > 0 && profile !== 'cliente_asipona'" class="badge">{{ pendingAppointments }}</span>
      <span class="tooltip-content">{{ menu.description }}</span>
    </figure>
  </div>

  <div class="container-logout">
    <figure (click)="logout()" class="tooltip-container">
      <i class="bi bi-box-arrow-right"></i>
      <span class="tooltip-content">Cerrar sesion</span>
    </figure>
  </div>
</nav>
